// extracted by mini-css-extract-plugin
export default {"homePage":"MasterPage_homePage__ieKfK"};